import { useQuery } from "@tanstack/react-query";
import { withNamespaces } from "react-i18next"
import { Card, CardHeader, Col, ListGroup, ListGroupItem, Row, Table } from "reactstrap";
import TaskManagerServices from "../../TaskManager/taskManagerServices";
import { toast } from "react-toastify";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";

const TasksStatuses = {
    "NEW": {
        title: "New",
        color: 'bg-success'
    },
    "IN_PROGRESS": {
        title: "In Progress",
        color: "bg-primary"
    },
    "REVIEW": {
        title: "Review",
        color: "bg-info"
    },
    "CLOSED": {
        title: "Closed",
        color: "bg-secondary"
    },
    "DELETED": {
        title: "Deleted",
        color: "bg-danger"
    },
}

const RecurringTaskData = ({
    t,
    task,
    onRelatedTaskClicked
}) => {
    const dateUtils = new DateUtils();

    const handleFetchRecurringTaskChildren = useQuery({
        queryKey: [
            'fetch-recurring-task-children',
            task.id
        ],
        queryFn: async () => {
            const service = new TaskManagerServices();

            return await service.fetchRecurringTaskChildren(task.id, {
                pageIndex: 1,
                pageSize: 100,
                sortField: 'id',
                sortOrder: 'ASC'
            });
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: !!(task.is_recurring && !task.parent_task?.id),
        onError: () => {
            toast(t('An error occurred while fetching recurring tasks.'), {
                type: 'error',
            });
        }
    });

    if (!task.is_recurring) return null;

    if (!task.parent_task?.id) {
        return (
            <Card
                outline
                body
                className='border border-primary rounded'
            >
                <CardHeader>
                    {t('Recurring Task Instances')}
                </CardHeader>

                <div
                    style={{
                        maxHeight: '300px',
                        overflowY: 'auto'
                    }}
                >
                    <Table
                        responsive
                    >
                        <thead>
                            <tr>
                                <th>
                                    {t('Title')}
                                </th>
                                <th>
                                    {t('Start Date')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {handleFetchRecurringTaskChildren.isFetching ? (
                                <tr>
                                    <td colSpan='2'>
                                        {t('Loading')}...
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {(handleFetchRecurringTaskChildren?.data?.tasks || []).map((childTask) => {
                                        const taskStatus = TasksStatuses[childTask.status];
                                        return (
                                            <tr>
                                                <td>
                                                    <span
                                                        className="btn-link"
                                                        style={{
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => {
                                                            onRelatedTaskClicked && onRelatedTaskClicked(childTask.id)
                                                        }}
                                                    >
                                                        {childTask.name + '-' + childTask.recurrence_secondary_id}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div
                                                        className='d-flex justify-content-center align-items-start flex-column'
                                                    >
                                                        {dateUtils.convertTimeStampToDate(
                                                            childTask.started_at, 
                                                            INTERNATIONAL_DATE_FORMAT
                                                        )}
                                                        <div className={`dt-task-status text-white ${taskStatus.color}`}>
                                                            {t(taskStatus.title)}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </>
                            )}
                        </tbody>
                    </Table>
                </div>

            </Card>
        )
    }

    return (
        <Card
            outline
            body
            className='border border-primary rounded'
            style={{
                width: 'auto',
            }}
        >
            <CardHeader>
                {t('This Is an Instance of a Recurring Task')}
            </CardHeader>
            <ListGroup flush>
                <ListGroupItem>
                    <Row>
                        <Col>
                            <p>{t('Parent Task')}</p>
                        </Col>
                        <Col>
                            <p
                                style={{
                                    cursor: 'pointer'
                                }}
                                className="btn-link"
                                onClick={() => {
                                    onRelatedTaskClicked && onRelatedTaskClicked(task.parent_task.id)
                                }}
                            >
                                {task.parent_task?.name}
                            </p>
                        </Col>
                    </Row>
                </ListGroupItem>
            </ListGroup>
        </Card>
    )
}

export default withNamespaces()(
    RecurringTaskData
)